module.exports = __webpack_public_path__ + "static/media/confcp_118.121535ab.ico";